import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { filter, map } from 'rxjs/operators';

import { FooterService } from './footer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {
  dataHeadTitle = '';
  dataSubTitle = '';
  constructor(
    private router: Router,
    private footerServ: FooterService,
    private activatedRoute: ActivatedRoute) {
      this.dataHeadTitle = this.routerInit();
      this.dataSubTitle = this.routerInit();
  }

  ngOnInit(): void {
    this.getProfile();
  }

  overviewData;
  percent = [];
  getProfile() {
    this.footerServ.getEnergyProfile().subscribe(
      (res:any) => {
        this.overviewData = res;
        this.overviewData = this.overviewData.quota.en;
        this.percent.push(Math.round((this.overviewData.yellow*100)/this.overviewData.total));
        this.percent.push(Math.round((this.overviewData.red*100)/this.overviewData.total));
        // console.log("this.overviewData:",this.overviewData);
        // console.log("this.percent:",this.percent);
      });
  }

  routerInit(): any{
    this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    )
    .subscribe(() => {

      var rt = this.getChild(this.activatedRoute)

      rt.data.subscribe(data => {
        this.dataHeadTitle = data.headTitle;
        this.dataSubTitle = data.subTitle;
      })
    })
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

}
